import url from '@/creditflowresearch/infrastructure/url';
import staticUrls from '@finsight/urls/static';

const getParentMetaSchema = (pathname: string, parentName: string) => {
  if (!parentName || !pathname) {
    return null;
  }
  return {
    '@type': 'ProfilePage',
    url: url.getUrl(pathname),
    name: `${ parentName } Profile`,
    description: `View ${ parentName }'s historical fixed income issuance and pricing profile here.`,
    keywords: [parentName, 'bonds', 'fixed income issuance'],
    hasPart: [
      {
        '@type': 'Dataset',
        name: parentName,
        description: `View ${ parentName }'s historical fixed income issuance and pricing profile here.`,
        license: staticUrls.getTermsOfUseUrl(),
      },
    ],
  };
};

export default getParentMetaSchema;
